import { BaseDetailPage } from 'src/app/@shared/base-detail-page';
import { Component, Input, inject } from '@angular/core';

import { DatasetFormCompleteStatus } from 'src/app/@shared/form/base-form.component';
import { PersonModel } from 'src/app/person/@shared/person.model';
import { ToastService } from 'src/app/@core/toast.service';

@Component({
  selector: 'page-person-edit',
  standalone: false,
  styleUrls: ['./person-edit.page.scss'],
  templateUrl: './person-edit.page.html',
})
export class PersonEditPage extends BaseDetailPage<PersonModel> {
  @Input() public item: PersonModel;

  public readonly pageTrackName = 'PersonEditPage';

  public isEditMode: boolean;

  protected isStaticPage: boolean = true;

  private toastService = inject(ToastService);

  public onProcessCompleted(processCompleted: DatasetFormCompleteStatus): void {
    switch (processCompleted) {
      case 'submitted':
        this.toastService.show(this.translate.instant('VIEW.COMMON.TOAST.SAVE_SUCCESS.MESSAGE')).catch();
        this.back().catch();
        break;

      case 'error':
        this.toastService.show(this.translate.instant('VIEW.COMMON.TOAST.SAVE_ERROR.MESSAGE'), {
          color: 'danger',
        }).catch();
        break;

      default:
        this.back().catch();
        break;
    }
  }

  public async back(): Promise<void> {
    await this.modalController.dismiss();

    return Promise.resolve();
  }

  protected protoOnInit(): void {
    this.isEditMode = !!this.item?.id;
  }
}
